var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42.0571,
    height: 42.0571,
    rx: 21.0286,
    fill: "#1489C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1631 30.1516V28.1562C28.1631 27.0978 27.7426 26.0827 26.9942 25.3343C26.2458 24.5859 25.2307 24.1654 24.1723 24.1654H17.1885C16.13 24.1654 15.115 24.5859 14.3666 25.3343C13.6181 26.0827 13.1977 27.0978 13.1977 28.1562V30.1516",
    stroke: "white",
    strokeWidth: 1.99539,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6803 20.1747C22.8844 20.1747 24.6711 18.3879 24.6711 16.1839C24.6711 13.9798 22.8844 12.1931 20.6803 12.1931C18.4763 12.1931 16.6896 13.9798 16.6896 16.1839C16.6896 18.3879 18.4763 20.1747 20.6803 20.1747Z",
    stroke: "white",
    strokeWidth: 1.99539,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.d2d0c7887aa3f702c7cec76999ea882b.svg";
export { ForwardRef as ReactComponent };